<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>

      <v-row class="mx-auto pa-2" no-gutters >
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <gallery-mobile v-model="data" />
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات گالری pdf</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="res.title"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام گالری شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام گالری"
                  />
                </div>
                
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion
                v-model="data"
                :components="specialInfo"
                :data="data"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import SocialMobile from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import GalleryMobile from "@/view/pages/otherQrTypes/pdfGallery/components/galleryMobile.vue";

export default {
  name: "editPdfModel",
  props:{
    id:{type:String, default:''},
  },
  components: {
    HelpInfo,
    HelpInfoWrapper,
    GalleryMobile,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    SocialMobile,
    QrMaker,
  },

  data() {
    return {
      orders: [],
      helpData: [],
      serviceName: "Qrland",
      componentName: "editPdf",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {},
      security: {},
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "افزودن گالری پی دی اف ",
          icon: "file",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],

    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },

  computed: {
  
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    fetchData() {
      this.loading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;

          let info = parsedData; 
          this.setCreatedQrID(data.data.id);
          this.res = data.data;
          this.data = info.data;
        })
        .finally(() => (this.loading = false));
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "pdfGallery",
        qrType: "dynamic",
        title: this.res.title,
        data: JSON.stringify({
          theme: '',
          data: this.data,
        }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };
      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "pdfGallery",
          title: this.res.title,
        })
        .then(({ data }) => {
          this.$toast.success("گالری pdf شما با موفقیت ویرایش شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        banner: undefined,
        blog: undefined,
        service: undefined,
        video_gallery: undefined,
        gallery: undefined,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: null }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: null,
        email: null,
        fax: null,
        location: null,
        city: null,
        codePostal: null,
        province: null,
        country: null,
        website: null,
        socialMedia: {},
        aboutUs: null,
        copyright: null,
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: null,
        pallete: {},
        visitName: "",

        pallete: {
          headColor: "linear-gradient(to top,#586F8A, #1A3870)",
          bodyColor: "linear-gradient(to bottom, #FFFFFF, #EBF6FFC5)",
          textColor: "#200101",
          borderColor: "#e2e8f0",
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        pdf: [
          {
            name: "",
            images: [],
          },
        ],
        photo: {
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        organizationName: "",
        subtitle: "",
        website: "",
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right, #ffffff, #F0F4F8)",
            text: "#1E293B",
          },
          slider: false,
          grid: false,
        },
        socialMedia: {},
        pdfSelector: {
          title: "لیست اسناد و فایل‌ها",
          description: "فایل مورد نظر خود را از لیست زیر انتخاب کنید:",
          sectionColor: {
            backGround: "#FFFFFF",
            text: "#333333",
          },
          slider: false,
          layout: "list",
        },

        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        PicSelector: {
          title: "گالری pdf",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            images: [],
          },
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        faqs: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
  },
};
</script>

<style scoped></style>
